<template>
	<div class="back" v-if="$route.path !== '/'">
		<a href="#" @click.prevent="$router.go(-1)">Вернуться назад</a>
	</div>
</template>

<script>
  export default {
    name: "back"
  }
</script>

<style lang="scss" scoped>
.back {
  padding: 10px;
}
</style>